import {FC} from 'react'
import useReactRouter from 'use-react-router'
import {useQuery} from 'hooks/graphql'
import {Presenter} from './Presenter'
import {PROCEDURE_STATUS, QueryVariables, QueryResult} from './query'

export const Update: FC = () => {
  const {match} = useReactRouter<{id: string}>()
  const id = match.params.id
  const {data, loading} = useQuery<QueryResult, QueryVariables>(PROCEDURE_STATUS, {variables: {id}})

  return !loading && data ? (
    <Presenter employee={data.client.procedureStatus.employee} procedureStatus={data.client.procedureStatus} />
  ) : (
    <></>
  )
}
